import * as React from "react";
import { RouteComponentProps } from "@reach/router";
import { COOKIE_JWT_ACCESS_TOKEN, COOKIE_JWT_ID_TOKEN, getCookie } from "lib/Cookies";

interface IRouteProps<IProps> {
  component: React.ComponentType<IProps & RouteComponentProps> | React.ComponentType<IProps>;
}

export function Route<IProps>(props: IProps & RouteComponentProps & IRouteProps<any>) {
  const Component = props.component;
  return <Component {...props} />;
}

export function ProtectedRoute<IProps>(props: IProps & RouteComponentProps & IRouteProps<any>) {
  const Component = props.component;
  // check if cookies have not expired - if so, remove the cookie which will cause
  // the AppID login logic to fire
  // (Note appID JS does not have concept of refresh token nor silentsignup as a IDP is being used)
  getCookie(COOKIE_JWT_ACCESS_TOKEN);
  getCookie(COOKIE_JWT_ID_TOKEN);
  return <Component {...props} />;
}
